import { render, staticRenderFns } from "./FormControlModulecomponentsNameField.vue?vue&type=template&id=bfd56018"
import script from "./FormControlModulecomponentsNameField.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulecomponentsNameField.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports